import styled from "styled-components";

export const BaseContainer = styled.div`
    margin: 0 auto;
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    padding : 0px 80px;
    box-sizing: border-box;
`;